<!--
Attention: The avano-layout css classes are available if you add /libs/avano-components/src/avano-components to your scss
-->
<ng-container *ngIf="isAuthenticated$ | async; else authenticationLoader">
  <scip-error-page *ngIf="userWithoutRoles$ | async; else ourApplication"></scip-error-page>

  <ng-template #ourApplication>
    <div [avanoLoadingIndicator]="appBlockingIdentifier">
      <!--
      Write a wrapper around the avano-appheader to have the logic which reacts to e.g. to the logout
      event in a dedicated small component instead of here in the app component.
      -->
      <scip-topbar class="avano-layout-appheader"></scip-topbar>
      <div class="avano-layout-appheader-placeholder"></div>
      <!--
      Use the styleclasses here so that some basic layout styles will get applied correctly and
      the placement of the appheader, the menu and the main content of your app is correctly
      -->
      <div class="avano-layout-content">
        <!--
      Write a wrapper around the avano-menu to have a single component which configures the avano-menu
      instead of having the whole logic within the app component. Put the styleclass avano-app-content-menu
      to correctly style it at this componentselector or put a div with this styleclass around your wrapper placement here
      -->
        <scip-menu class="avano-layout-content-menu"></scip-menu>
        <!--
        The main content of the application is placed within this div
        it will also serve as the scrollcontainer, but the better approach would be to flex
        your components so that the scrolling is even happening inside them (e.g. within the
        datatable instead of the whole table/content)
        -->
        <div class="avano-layout-content-main">
          <avano-toaster class="avano-toaster-no-capitalize"></avano-toaster>
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
    <!--
    Additional parts which e.g. should be able to overlay the application (z-index + position in dom)
    -->
    <avano-unsaved-changes-dialog></avano-unsaved-changes-dialog>
  </ng-template>
</ng-container>

<ng-template #authenticationLoader>
  <scip-login></scip-login>
</ng-template>
